import { IFilter } from "@saleor/components/Filter";
import { FilterOpts } from "@saleor/types";
import { createOptionsField } from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

export enum ClusterFilterKeys {
  productType = "productType",
  status = "status"
}

export interface ClusterListUrlFiltersOpts {
  productType: FilterOpts<ClusterProductType>;
}

export enum ClusterProductType {
  FOOD = "F&B",
  GENMERCH = "GENERAL_MERCHANDISE"
}

const messages = defineMessages({
  food: {
    defaultMessage: "F&B",
    description: "Product Type Status"
  },
  genMerch: {
    defaultMessage: "General Merchandise",
    description: "Product Type Status"
  },
  productType: {
    defaultMessage: "Product Type",
    description: "Product Type Status"
  },
  started: {
    defaultMessage: "Date Range",
    description: "voucher start date"
  },
  status: {
    defaultMessage: "Status",
    description: "Status"
  },
  unpublished: {
    defaultMessage: "Unpublished",
    description: "Unpublished Status"
  }
});

export function createFilterStructure(
  intl: IntlShape,
  opts: ClusterListUrlFiltersOpts
): IFilter<ClusterFilterKeys> {
  return [
    {
      ...createOptionsField(
        ClusterFilterKeys.productType,
        intl.formatMessage(messages.productType),
        [opts.productType.value],
        false,
        [
          {
            label: intl.formatMessage(messages.food),
            value: ClusterProductType.FOOD
          },
          {
            label: intl.formatMessage(messages.genMerch),
            value: ClusterProductType.GENMERCH
          }
        ]
      ),
      active: opts.productType.active
    }
  ];
}
